// Minimální router nad History API: domů, chat (/c/:id), pohled (/v/:id) a přepisy (/prepisy/:klient).
import { useSyncExternalStore } from 'react';

export type Route = { t: 'home' } | { t: 'chat'; id: string } | { t: 'view'; id: string } | { t: 'transcripts'; id: string | null };

export function parseRoute(pathname: string): Route {
  const tr = pathname.match(/^\/prepisy(?:\/([^/]+))?\/?$/);
  if (tr) return { t: 'transcripts', id: tr[1] ? decodeURIComponent(tr[1]) : null };
  const m = pathname.match(/^\/(c|v)\/([A-Za-z0-9_-]+)\/?$/);
  if (!m) return { t: 'home' };
  return m[1] === 'c' ? { t: 'chat', id: m[2] } : { t: 'view', id: m[2] };
}

const listeners = new Set<() => void>();
const subscribe = (fn: () => void) => {
  listeners.add(fn);
  window.addEventListener('popstate', fn);
  return () => {
    listeners.delete(fn);
    window.removeEventListener('popstate', fn);
  };
};

export function navigate(to: string, opts: { replace?: boolean } = {}) {
  if (to === window.location.pathname) return;
  if (opts.replace) history.replaceState(null, '', to);
  else history.pushState(null, '', to);
  for (const l of listeners) l();
}

export function useRoute(): Route {
  const path = useSyncExternalStore(subscribe, () => window.location.pathname);
  return parseRoute(path);
}

export const chatPath = (id: string) => `/c/${id}`;
export const viewPath = (id: string) => `/v/${id}`;
